<template>
	<div>
		<div class="events-layout" :class="{ 'event-layout-darker': $route.name === 'events-teams-join' }">
			<events-header />
			<div class="position-relative">
				<nuxt />
			</div>
			<modal />
		</div>
		<chat />
		<toaster />
		<events-footer />
	</div>
</template>

<script>
import EventsHeader from '~/components/EventsHeader'
import EventsFooter from '~/components/EventsFooter'
import Toaster from '~/components/managers/Toaster'
import Modal from '~/components/managers/Modal'
import Chat from '~/components/interface/Chat'

export default {
	name: 'Events',
	components: { EventsFooter, EventsHeader, Toaster, Chat, Modal }
}
</script>

<style>
	body .siq_bR {
		bottom: 50px;
	}
	body .zsiq_theme1 div.zsiq_cnt {
		display: none;
	}
</style>
